"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Form = _interopRequireDefault(require("../hocs/Form"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useForm
} = _Form.default;
function VirtualInputs(_ref) {
  let {
    fields
  } = _ref;
  const {
    register
  } = useForm();
  return /*#__PURE__*/_react.default.createElement(Container, {
    disabled: true
  }, fields.map((_ref2, index) => {
    let {
      name,
      defaultValue
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("input", _extends({
      key: "".concat(name, "-").concat(index),
      defaultValue: defaultValue
    }, register(name)));
  }));
}
const Container = _styled.default.fieldset(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: none;\n"])));
var _default = exports.default = VirtualInputs;